import axios from "axios";
import toQueryString from "../common/utils/to-query-string";

const start = () => axios.post("api/v1/admin/task-graph-migration/start");
const stop = () => axios.post("api/v1/admin/task-graph-migration/stop");
const getStatus = () => axios.get("api/v1/admin/task-graph-migration/status");
const getJournal = (query) =>
  axios.get(toQueryString("api/v1/admin/task-graph-migration/journal?", query || {}));

const ApiTaskGraphMigration = { start, stop, getStatus, getJournal };

export default ApiTaskGraphMigration;
